import { render, staticRenderFns } from "./CreateReferralCampaign.vue?vue&type=template&id=5c3e23b8&scoped=true&"
import script from "./CreateReferralCampaign.vue?vue&type=script&lang=js&"
export * from "./CreateReferralCampaign.vue?vue&type=script&lang=js&"
import style0 from "./CreateReferralCampaign.vue?vue&type=style&index=0&id=5c3e23b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3e23b8",
  null
  
)

export default component.exports